import {
    GETCUSTOMERIDANDNAMEADMINLIST_SUCCESS,
    GETCUSTOMERIDANDNAMEADMINLIST_FAILED,
    RESET_GETCUSTOMERIDANDNAMEADMINLIST,
    LOADING_GETCUSTOMERIDANDNAMEADMINLIST,
    NETWORK_ERROR_GETCUSTOMERIDANDNAMEADMINLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetCustomerIdAndNameAdminList = () => {
    return { type: RESET_GETCUSTOMERIDANDNAMEADMINLIST };
};

const getCustomerIDANDNameAdminList =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETCUSTOMERIDANDNAMEADMINLIST });
        await partnerServices
            .post("getCustomerIdAndNameList", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "Success":
                        dispatch(getCustomerIdAndNameAdminListsuccess(res.data));
                        break;
                    default:
                        dispatch(getCustomerIdAndNameAdminListFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETCUSTOMERIDANDNAMEADMINLIST,
                    payload: err,
                });
            });
    };
function getCustomerIdAndNameAdminListsuccess(data) {
    return {
        type: GETCUSTOMERIDANDNAMEADMINLIST_SUCCESS,
        payload: data,
    };
}
function getCustomerIdAndNameAdminListFailed(data) {
    return {
        type: GETCUSTOMERIDANDNAMEADMINLIST_FAILED,
        payload: data,
    };
}

export { resetGetCustomerIdAndNameAdminList, getCustomerIDANDNameAdminList };
